import { render, staticRenderFns } from "./equipmentAlarm.vue?vue&type=template&id=f148280a&scoped=true"
import script from "./equipmentAlarm.vue?vue&type=script&lang=js"
export * from "./equipmentAlarm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f148280a",
  null
  
)

export default component.exports